import { FormConfig, createFormFromConfig } from './GenericFormTemplate';

// ============================================
// CONFIGURAÇÕES DOS FORMULÁRIOS DE TRÂNSITO
// ============================================

// Defesa Prévia (DETRAN)
export const DEFESA_PREVIA_DETRAN_CONFIG: FormConfig = {
  formType: 'peticao_inicial',
  title: 'Defesa Prévia (DETRAN)',
  description: 'Defesa administrativa contra autuação de trânsito',
  suggestedDocs: 'Auto de infração, CNH, CRLV e fotos/vídeos do local.',
  infoTip: 'Apresente os argumentos de defesa e provas que demonstrem a improcedência da autuação.',
};
export const DefesaPreviaDetranForm = createFormFromConfig(DEFESA_PREVIA_DETRAN_CONFIG);

// Recurso à JARI
export const RECURSO_JARI_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Recurso à JARI',
  description: 'Recurso à Junta Administrativa de Recursos de Infrações',
  suggestedDocs: 'Auto de infração, Decisão da defesa prévia e Documentos comprobatórios.',
  defaultPecaRebater: 'Decisão da Defesa Prévia',
  pecaRebaterHelper: 'Indique a decisão que indeferiu a defesa prévia',
  infoTip: 'Demonstre o erro da decisão e apresente novos argumentos ou provas.',
};
export const RecursoJARIForm = createFormFromConfig(RECURSO_JARI_CONFIG);

// Recurso ao CETRAN
export const RECURSO_CETRAN_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Recurso ao CETRAN',
  description: 'Recurso ao Conselho Estadual de Trânsito',
  suggestedDocs: 'Auto de infração, Decisão da JARI e Documentos comprobatórios.',
  defaultPecaRebater: 'Decisão da JARI',
  pecaRebaterHelper: 'Indique a decisão da JARI que deseja recorrer',
  infoTip: 'Último recurso administrativo - demonstre o erro da JARI com fundamentação sólida.',
};
export const RecursoCETRANForm = createFormFromConfig(RECURSO_CETRAN_CONFIG);

// Manifestação Processual (Trânsito)
export const MANIFESTACAO_TRANSITO_CONFIG: FormConfig = {
  formType: 'resposta_com_tipo',
  title: 'Manifestação Processual (Trânsito)',
  description: 'Manifestação genérica em processo de trânsito',
  suggestedDocs: 'Processo na íntegra.',
  defaultPecaRebater: '',
  pecaRebaterHelper: 'Ex. Despacho judicial feito na data de 21/05/2025',
  infoTip: 'Manifeste-se sobre o ponto específico determinado pelo juízo ou de interesse da parte.',
};
export const ManifestacaoTransitoForm = createFormFromConfig(MANIFESTACAO_TRANSITO_CONFIG);

// Petição Inicial (Trânsito)
export const PETICAO_INICIAL_TRANSITO_CONFIG: FormConfig = {
  formType: 'peticao_inicial',
  title: 'Petição Inicial (Trânsito)',
  description: 'Ação judicial relacionada a questões de trânsito',
  suggestedDocs: 'Auto de infração, Recursos administrativos e Decisões do DETRAN/JARI/CETRAN.',
  infoTip: 'Demonstre a ilegalidade da autuação ou decisão administrativa e fundamente o pedido judicial.',
};
export const PeticaoInicialTransitoForm = createFormFromConfig(PETICAO_INICIAL_TRANSITO_CONFIG);

// Contraminuta ao Agravo de Instrumento (Trânsito)
export const CONTRAMINUTA_AGRAVO_TRANSITO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Contraminuta ao Agravo de Instrumento (Trânsito)',
  description: 'Resposta ao agravo de instrumento em processo de trânsito',
  suggestedDocs: 'Agravo de instrumento, Decisão agravada e Processo na íntegra.',
  defaultPecaRebater: 'Agravo de Instrumento',
  pecaRebaterHelper: 'Indique o agravo de instrumento que deseja responder',
  infoTip: 'Defenda a manutenção da decisão agravada.',
};
export const ContraminutaAgravoTransitoForm = createFormFromConfig(CONTRAMINUTA_AGRAVO_TRANSITO_CONFIG);

// Contrarrazões ao Recurso Especial (Trânsito)
export const CONTRARRAZOES_RESP_TRANSITO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Contrarrazões ao Recurso Especial (Trânsito)',
  description: 'Resposta ao REsp em processo de trânsito',
  suggestedDocs: 'Acórdão, Processo na íntegra e REsp.',
  defaultPecaRebater: 'Recurso Especial',
  pecaRebaterHelper: 'Indique o recurso especial que deseja contrarrazoar',
  infoTip: 'Demonstre a correção do acórdão recorrido.',
};
export const ContrarrazoesRespTransitoForm = createFormFromConfig(CONTRARRAZOES_RESP_TRANSITO_CONFIG);

// Contrarrazões ao Recurso Extraordinário (Trânsito)
export const CONTRARRAZOES_RE_TRANSITO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Contrarrazões ao Recurso Extraordinário (Trânsito)',
  description: 'Resposta ao RE em processo de trânsito',
  suggestedDocs: 'Acórdão, Processo na íntegra e RE.',
  defaultPecaRebater: 'Recurso Extraordinário',
  pecaRebaterHelper: 'Indique o recurso extraordinário que deseja contrarrazoar',
  infoTip: 'Demonstre a ausência de repercussão geral ou inexistência de violação à Constituição.',
};
export const ContrarrazoesRETransitoForm = createFormFromConfig(CONTRARRAZOES_RE_TRANSITO_CONFIG);

// Contrarrazões aos Embargos de Declaração (Trânsito)
export const CONTRARRAZOES_ED_TRANSITO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Contrarrazões aos Embargos de Declaração (Trânsito)',
  description: 'Resposta aos embargos declaratórios em processo de trânsito',
  suggestedDocs: 'Embargos de declaração e Decisão embargada.',
  defaultPecaRebater: 'Embargos de Declaração',
  pecaRebaterHelper: 'Indique os embargos de declaração que deseja contrarrazoar',
  infoTip: 'Demonstre a inexistência de omissão, contradição ou obscuridade.',
};
export const ContrarrazoesEDTransitoForm = createFormFromConfig(CONTRARRAZOES_ED_TRANSITO_CONFIG);

// Contrarrazões de Apelação (Trânsito)
export const CONTRARRAZOES_APELACAO_TRANSITO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Contrarrazões de Apelação (Trânsito)',
  description: 'Resposta à apelação em processo de trânsito',
  suggestedDocs: 'Apelação, Processo na íntegra e Sentença.',
  defaultPecaRebater: 'Apelação',
  pecaRebaterHelper: 'Indique a apelação que deseja contrarrazoar',
  infoTip: 'Defenda a manutenção da sentença, rebatendo os argumentos da apelação.',
};
export const ContrarrazoesApelacaoTransitoForm = createFormFromConfig(CONTRARRAZOES_APELACAO_TRANSITO_CONFIG);

// Embargos de Declaração (Trânsito)
export const EMBARGOS_DECLARACAO_TRANSITO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Embargos de Declaração (Trânsito)',
  description: 'Recurso para sanar omissão, contradição ou obscuridade',
  suggestedDocs: 'Decisão embargada e Processo na íntegra.',
  defaultPecaRebater: 'Decisão Embargada',
  pecaRebaterHelper: 'Indique a decisão que contém vício a ser sanado',
  infoTip: 'Aponte especificamente a omissão, contradição ou obscuridade da decisão.',
};
export const EmbargosDeclaracaoTransitoForm = createFormFromConfig(EMBARGOS_DECLARACAO_TRANSITO_CONFIG);

// Embargos de Terceiro (Trânsito)
export const EMBARGOS_TERCEIRO_TRANSITO_CONFIG: FormConfig = {
  formType: 'peticao_inicial',
  title: 'Embargos de Terceiro (Trânsito)',
  description: 'Defesa de terceiro atingido por ato de constrição judicial',
  suggestedDocs: 'Documento que comprova a propriedade/posse, Auto de penhora e Processo principal.',
  infoTip: 'Demonstre a propriedade ou posse do bem constrito e que não é parte no processo.',
};
export const EmbargosTerceiroTransitoForm = createFormFromConfig(EMBARGOS_TERCEIRO_TRANSITO_CONFIG);

// Exceção de Pré-executividade (Trânsito)
export const EXCECAO_PRE_EXECUTIVIDADE_TRANSITO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Exceção de Pré-executividade (Trânsito)',
  description: 'Defesa em execução fiscal de multas de trânsito',
  suggestedDocs: 'CDA, Execução fiscal e Provas da nulidade.',
  defaultPecaRebater: 'Execução Fiscal',
  pecaRebaterHelper: 'Indique a execução fiscal que deseja impugnar',
  infoTip: 'Alegue matérias de ordem pública que dispensam dilação probatória.',
};
export const ExcecaoPreExecutividadeTransitoForm = createFormFromConfig(EXCECAO_PRE_EXECUTIVIDADE_TRANSITO_CONFIG);

// Impugnação à Contestação (Réplica) (Trânsito)
export const REPLICA_TRANSITO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Impugnação à Contestação (Réplica) (Trânsito)',
  description: 'Resposta à contestação em processo de trânsito',
  suggestedDocs: 'Contestação, Petição inicial e Processo na íntegra.',
  defaultPecaRebater: 'Contestação',
  pecaRebaterHelper: 'Indique a contestação que deseja rebater',
  infoTip: 'Rebata os argumentos da contestação e reforce seu direito.',
};
export const ReplicaTransitoForm = createFormFromConfig(REPLICA_TRANSITO_CONFIG);

// Impugnação ao Cumprimento de Sentença (Trânsito)
export const IMPUGNACAO_CUMPRIMENTO_TRANSITO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Impugnação ao Cumprimento de Sentença (Trânsito)',
  description: 'Defesa ao cumprimento de sentença em processo de trânsito',
  suggestedDocs: 'Cálculos, Cumprimento de sentença e Processo na íntegra.',
  defaultPecaRebater: 'Cumprimento de Sentença',
  pecaRebaterHelper: 'Indique o pedido de cumprimento de sentença que deseja impugnar',
  infoTip: 'Aponte excesso de execução ou outras matérias de defesa.',
};
export const ImpugnacaoCumprimentoTransitoForm = createFormFromConfig(IMPUGNACAO_CUMPRIMENTO_TRANSITO_CONFIG);

// Impugnação aos Embargos à Execução (Trânsito)
export const IMPUGNACAO_EMBARGOS_EXECUCAO_TRANSITO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Impugnação aos Embargos à Execução (Trânsito)',
  description: 'Resposta aos embargos à execução em processo de trânsito',
  suggestedDocs: 'Embargos à execução, Execução e Processo na íntegra.',
  defaultPecaRebater: 'Embargos à Execução',
  pecaRebaterHelper: 'Indique os embargos à execução que deseja impugnar',
  infoTip: 'Rebata os argumentos dos embargos e defenda a regularidade da execução.',
};
export const ImpugnacaoEmbargosExecucaoTransitoForm = createFormFromConfig(IMPUGNACAO_EMBARGOS_EXECUCAO_TRANSITO_CONFIG);

// Impugnação à Sentença de Homologação dos Cálculos (Trânsito)
export const IMPUGNACAO_HOMOLOGACAO_TRANSITO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Impugnação à Sentença de Homologação dos Cálculos (Trânsito)',
  description: 'Discordância dos cálculos homologados em processo de trânsito',
  suggestedDocs: 'Planilha de cálculos, Processo na íntegra e Sentença homologatória.',
  defaultPecaRebater: 'Sentença de Homologação dos Cálculos',
  pecaRebaterHelper: 'Indique a sentença que homologou os cálculos',
  infoTip: 'Aponte especificamente os erros de cálculo, sob pena de preclusão.',
};
export const ImpugnacaoHomologacaoTransitoForm = createFormFromConfig(IMPUGNACAO_HOMOLOGACAO_TRANSITO_CONFIG);

// Inicial de Ação de Execução de Título Extrajudicial (Trânsito)
export const EXECUCAO_TITULO_TRANSITO_CONFIG: FormConfig = {
  formType: 'peticao_inicial',
  title: 'Inicial de Ação de Execução de Título Extrajudicial (Trânsito)',
  description: 'Execução de título extrajudicial relacionado a trânsito',
  suggestedDocs: 'Título executivo, Planilha de débito e Documentos de qualificação.',
  infoTip: 'Apresente o título executivo e demonstre a liquidez, certeza e exigibilidade do crédito.',
};
export const ExecucaoTituloTransitoForm = createFormFromConfig(EXECUCAO_TITULO_TRANSITO_CONFIG);

// Mandado de Segurança (Trânsito)
export const MANDADO_SEGURANCA_TRANSITO_CONFIG: FormConfig = {
  formType: 'peticao_inicial',
  title: 'Mandado de Segurança (Trânsito)',
  description: 'Proteção a direito líquido e certo violado por autoridade de trânsito',
  suggestedDocs: 'Ato coator, Provas do direito líquido e certo e Processo administrativo.',
  infoTip: 'Demonstre claramente o direito líquido e certo e a ilegalidade ou abuso de poder.',
};
export const MandadoSegurancaTransitoForm = createFormFromConfig(MANDADO_SEGURANCA_TRANSITO_CONFIG);

// Manifestação à Impugnação aos Embargos à Execução (Trânsito)
export const MANIFESTACAO_IMPUGNACAO_EMBARGOS_TRANSITO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Manifestação à Impugnação aos Embargos à Execução (Trânsito)',
  description: 'Resposta à impugnação aos embargos em processo de trânsito',
  suggestedDocs: 'Impugnação, Embargos à execução e Processo na íntegra.',
  defaultPecaRebater: 'Impugnação aos Embargos',
  pecaRebaterHelper: 'Indique a impugnação que deseja responder',
  infoTip: 'Rebata os argumentos da impugnação e reforce os fundamentos dos embargos.',
};
export const ManifestacaoImpugnacaoEmbargosTransitoForm = createFormFromConfig(MANIFESTACAO_IMPUGNACAO_EMBARGOS_TRANSITO_CONFIG);

// Manifestação para Produção de Provas (Trânsito)
export const PRODUCAO_PROVAS_TRANSITO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Manifestação para Produção de Provas (Trânsito)',
  description: 'Requerimento de produção de provas em processo de trânsito',
  suggestedDocs: 'Despacho que determinou especificação de provas e Processo na íntegra.',
  defaultPecaRebater: 'Despacho',
  pecaRebaterHelper: 'Indique o despacho que determinou a especificação de provas',
  infoTip: 'Especifique as provas necessárias e justifique a pertinência de cada uma.',
};
export const ProducaoProvasTransitoForm = createFormFromConfig(PRODUCAO_PROVAS_TRANSITO_CONFIG);

// Recurso Especial (Trânsito)
export const RECURSO_ESPECIAL_TRANSITO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Recurso Especial (Trânsito)',
  description: 'Recurso ao STJ por violação à lei federal em matéria de trânsito',
  suggestedDocs: 'Acórdão, Embargos de declaração e Processo na íntegra.',
  defaultPecaRebater: 'Acórdão',
  pecaRebaterHelper: 'Indique o acórdão que violou lei federal',
  infoTip: 'Demonstre a violação à lei federal ou a divergência jurisprudencial.',
};
export const RecursoEspecialTransitoForm = createFormFromConfig(RECURSO_ESPECIAL_TRANSITO_CONFIG);

// Recurso Extraordinário (Trânsito)
export const RECURSO_EXTRAORDINARIO_TRANSITO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Recurso Extraordinário (Trânsito)',
  description: 'Recurso ao STF por violação à Constituição em matéria de trânsito',
  suggestedDocs: 'Acórdão, Decisão de admissibilidade e Processo na íntegra.',
  defaultPecaRebater: 'Acórdão',
  pecaRebaterHelper: 'Indique o acórdão que viola a Constituição',
  infoTip: 'Demonstre a violação direta à Constituição e a repercussão geral da matéria.',
};
export const RecursoExtraordinarioTransitoForm = createFormFromConfig(RECURSO_EXTRAORDINARIO_TRANSITO_CONFIG);

// Recurso Inominado (Trânsito)
export const RECURSO_INOMINADO_TRANSITO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Recurso Inominado (Trânsito)',
  description: 'Recurso contra sentença do Juizado Especial em matéria de trânsito',
  suggestedDocs: 'Processo na íntegra e Sentença.',
  defaultPecaRebater: 'Sentença',
  pecaRebaterHelper: 'Indique a sentença que deseja recorrer',
  infoTip: 'Demonstre o erro da sentença e fundamente o pedido de reforma.',
};
export const RecursoInominadoTransitoForm = createFormFromConfig(RECURSO_INOMINADO_TRANSITO_CONFIG);

// Agravo de Instrumento (Trânsito)
export const AGRAVO_INSTRUMENTO_TRANSITO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Agravo de Instrumento (Trânsito)',
  description: 'Recurso contra decisões interlocutórias em processo de trânsito',
  suggestedDocs: 'Decisão agravada e Processo na íntegra.',
  defaultPecaRebater: 'Decisão Interlocutória',
  pecaRebaterHelper: 'Indique a decisão interlocutória que deseja agravar',
  infoTip: 'Demonstre o erro da decisão interlocutória e o prejuízo causado à parte.',
};
export const AgravoInstrumentoTransitoForm = createFormFromConfig(AGRAVO_INSTRUMENTO_TRANSITO_CONFIG);

// Manifestação para Apresentação de Quesitos Periciais (Trânsito)
export const QUESITOS_PERICIAIS_TRANSITO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Manifestação para Apresentação de Quesitos Periciais (Trânsito)',
  description: 'Formulação de quesitos para perícia em processo de trânsito',
  suggestedDocs: 'Despacho que determinou a perícia e Processo na íntegra.',
  defaultPecaRebater: 'Despacho que determina apresentação de quesitos',
  pecaRebaterHelper: 'Indique o despacho que determinou a apresentação de quesitos',
  infoTip: 'Formule quesitos objetivos e relevantes para esclarecer os fatos do caso.',
};
export const QuesitosPericiaisisTransitoForm = createFormFromConfig(QUESITOS_PERICIAIS_TRANSITO_CONFIG);

// Memoriais Recursais (Trânsito)
export const MEMORIAIS_TRANSITO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Memoriais Recursais (Trânsito)',
  description: 'Memoriais para julgamento de recurso em processo de trânsito',
  suggestedDocs: 'Acórdão, Processo na íntegra, Razões recursais e Sentença.',
  defaultPecaRebater: 'Razões Recursais',
  pecaRebaterHelper: 'Indique as razões recursais apresentadas',
  infoTip: 'Reforce os principais argumentos do recurso e apresente jurisprudência favorável.',
};
export const MemoriaisTransitoForm = createFormFromConfig(MEMORIAIS_TRANSITO_CONFIG);

// Peça a partir de Modelo (Trânsito)
export const PECA_MODELO_TRANSITO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Peça a partir de Modelo (Trânsito)',
  description: 'Adaptar modelo de peça para novo caso de trânsito',
  suggestedDocs: 'Modelo a ser adaptado e documentos do novo caso.',
  defaultPecaRebater: 'Modelo Original',
  pecaRebaterHelper: 'Faça upload do modelo que deseja adaptar',
  infoTip: 'A IA adaptará a estrutura e argumentos do modelo para os fatos do seu caso.',
};
export const PecaModeloTransitoForm = createFormFromConfig(PECA_MODELO_TRANSITO_CONFIG);

// Recurso Ordinário Constitucional (Trânsito)
export const RECURSO_ORDINARIO_CONSTITUCIONAL_TRANSITO_CONFIG: FormConfig = {
  formType: 'resposta_simples',
  title: 'Recurso Ordinário Constitucional (Trânsito)',
  description: 'Recurso ao STF/STJ em mandado de segurança de trânsito',
  suggestedDocs: 'Acórdão denegatório, Processo na íntegra e Sentença.',
  defaultPecaRebater: 'Decisão Denegatória',
  pecaRebaterHelper: 'Indique a decisão que denegou a ordem',
  infoTip: 'Demonstre o cabimento do ROC e as razões para reforma da decisão.',
};
export const RecursoOrdinarioConstitucionalTransitoForm = createFormFromConfig(RECURSO_ORDINARIO_CONSTITUCIONAL_TRANSITO_CONFIG);

